export default [
  {
    description: 'Mensagens e Bloqueios',
    path: '/ferramentas/avisosBloqueios',
    name: 'avisosBloqueios',
    component: () => import('@/views/ferramentas/manutencao/Index.vue'),
    meta: {
      isLegacy: false,
      permissions: [
      ],
    },
    goesToMenu: true,
  },
]

